import '../ui/modal.css';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

/**
 * Ecrã de espera, usado enquanto o menu ou um chunk ainda não chegaram.
 *
 * Era um emoji de gelado a saltar. Um emoji é desenhado pelo sistema
 * operativo, por isso não havia forma de o pôr na cor da casa nem de garantir
 * que tinha o mesmo aspecto no telemóvel do cliente e no ecrã da cozinha.
 */
const Loader = ({ texto }: { texto?: string }) => {
  const { t } = useTranslation();
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    const timer = window.setTimeout(() => setSlow(true), 12_000);
    return () => window.clearTimeout(timer);
  }, []);
  return (
    <div className="surface">
      <div className="loader" role="status" aria-live="polite">
        <span className="loader-spinner" aria-hidden="true" />
        <span>{texto ?? t('loading')}</span>
        {slow && <><p>O carregamento está a demorar. Verifique a ligação ao servidor.</p>
          <button type="button" className="btn accent" onClick={() => window.location.reload()}>Voltar a carregar</button></>}
      </div>
    </div>
  );
};

export default Loader;
